export const iconFontAwesomeMedicalHealthThermometer = (
	<i className="fa-solid fa-thermometer"></i>
);
